import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ContentUnion",
  "use": "icon-ContentUnion-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ContentUnion\"><path fill=\"#333333\" d=\"M703.9 319.9v-256h-640v640h256v256h640v-640h-256z m-512 256v-384h384v128h-256v256h-128z m384-128v128h-128v-128h128z m256 384h-384v-128h256v-256h128v384z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol